import React from "react";

import { ColDef } from "ag-grid-community";
import { useSelector, useDispatch } from "react-redux";

import { updateDeploymentAttributes } from "actions";

import { UPDATE_DEPLOYMENT_SEXES } from "constants/actionTypes";

import Table, {
  DeploymentAttributeRow,
} from "containers/Settings/DeploymentAttributesTable";
import { HeaderBulkSelectCellRenderer } from "containers/Settings/Renderers";

import { getActiveSpeciesAttributes } from "lib/speciesAttributes";

import { getDeploymentAttributes, getSexes } from "selectors";

const columnDefs: ColDef<DeploymentAttributeRow>[] = [
  { headerName: "Name", field: "name", rowDrag: true, editable: false },
  {
    headerName: "Use",
    field: "is_used",
    cellRenderer: "checkboxRenderer",
    editable: false,
    headerComponent: HeaderBulkSelectCellRenderer,
  },
];

export const SexSettings = () => {
  const sexes = getActiveSpeciesAttributes(useSelector(getSexes));
  const deploymentData = Object.values(
    useSelector(getDeploymentAttributes).sexes,
  );

  const dispatch = useDispatch();

  const handleUpdate = payload =>
    dispatch(updateDeploymentAttributes(UPDATE_DEPLOYMENT_SEXES, payload));

  return (
    <Table
      dataKey="sex_id"
      baseData={sexes}
      deploymentData={deploymentData}
      handleUpdate={handleUpdate}
      columnDefs={columnDefs}
    />
  );
};
